import React from "react";
import { render } from "react-dom";
import { Provider } from "react-redux";
import { store, config } from "./_helpers";
import { App } from "./App";
import * as Sentry from "@sentry/react";
import { Integrations } from "@sentry/tracing";
import { QueryClient, QueryClientProvider } from "react-query";

Sentry.init({
  dsn: config.dsn,
  //release:"Firestorm App@v1.0",
  integrations: [new Integrations.BrowserTracing()],
  tracesSampleRate: 1.0,
});

// Set favicon dynamically using assetUrl from config
if (config.assetUrl) {
  const faviconLink = document.querySelector("link[rel='shortcut icon']") || document.querySelector("link[rel='icon']");
  if (faviconLink) {
    faviconLink.href = "https://d2t6semrip28lv.cloudfront.net/live/assets/favicon.ico";
  } else {
    const link = document.createElement("link");
    link.rel = "shortcut icon";
    link.href = "https://d2t6semrip28lv.cloudfront.net/live/assets/favicon.ico";
    document.head.appendChild(link);
  }
}

// Create a QueryClient instance
const queryClient = new QueryClient();

render(
  <Provider store={store}>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </Provider>,
  document.getElementById("app"),
);
